// Relatorio
import relatorioGerador from './gerador';

export default {
  relatorioGerador,
};
